module.exports = __webpack_public_path__ + "img/pay-bar-bg.d34959fe.png";